import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-retail",
  templateUrl: "./retail.component.html",
  styleUrls: ["./retail.component.scss"],
})
export class RetailComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
